/* =========================================================
   Category Slider — open/close + sub-menu toggle
   Add this file as: assets/header-aura-category-slider.js
   ========================================================= */
(function () {
  var openBtns = document.querySelectorAll('[data-aura-category-open]');
  var closeBtn = document.querySelector('[data-aura-category-close]');
  var overlay = document.querySelector('[data-aura-category-overlay]');
  var panel = document.querySelector('[data-aura-category-panel]');

  if (!panel || !overlay) return;

  function openPanel() {
    panel.classList.add('is-open');
    overlay.classList.add('is-visible');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    openBtns.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  function closePanel() {
    panel.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    openBtns.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openPanel();
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closePanel);
  }

  overlay.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
  });

  // Expand/collapse categories that have sub-links
  var items = panel.querySelectorAll('.aura-category-panel__item.has-children > .aura-category-panel__link');
  items.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      link.parentElement.classList.toggle('is-expanded');
    });
  });
})();
